import {encrypt, decrypt} from "./crypto.js"

/**
@typedef {Object} Session
@property {string} hash 
@property {string} key 
*/

/**
@typedef {Object} User
@property {string} name
@property {string} id
@property {string[]} groups
@property {string[]} privileges
@property {Object<string, Object>} preferences
*/

/**
@typedef {Object} AuthVars
@property {Session} session
@property {User} user
@property {Object.<str,str>} groups
@property {Object.<str,str>} names
*/


/**
@param {string} message 
@returns {never}
*/
export function communicationError(message) {
    alert(message);
    throw new Error(message);
}

/**
@param {Session} session 
@param {string} command 
@param {Object} body 
@returns {Promise<Response>}
*/
export async function apiRequest(session, command, body) {
    const resp = await fetch("/api", {
        method: "POST",
        headers: [["Content-Type", "application/json"]],
        body: JSON.stringify({
            hash: session.hash,
            body: encrypt(JSON.stringify({
                command: command,
                body: body
            }), session.key)
        })
    });
    if (resp.status == 401) logout();
    return resp;
}

/**
@param {Session} session 
@param {Response} resp 
@returns {Promise<Object>}
*/
export async function apiResponseBody(session, resp) {
    return JSON.parse(decrypt(await resp.json(), session.key));
}

/**
@param {Session} session 
@param {string} command 
@param {{}} [args={}]
@param {string} [errorMessage=""]
*/
export async function apiFetchResource(session, command, args = {}, errorMessage = "") {
    const resp = await apiRequest(session, command, args);
    if (!resp.ok) communicationError(errorMessage || `Erreurs lors du chargement de '${command}'`);
    return await apiResponseBody(session, resp);
}

/** @returns {never} */
export function logout() {
    localStorage.clear();
    window.location = "/login";
    throw new Error("logging out");
}

/** @returns {Promise<{session: Session, user: User, groups: Object.<string, string>, names: Object.<string, string>}>} */
export async function checkSession_getSelf() {
    try {
        /** @type {Session?} */
        const session = JSON.parse(localStorage.getItem("session"));
        if (!(session && session.key && session.hash)) logout();

        const resp = await apiRequest(session, "users.self", {});

        if (!resp.ok) {
            alert("Erreur lors de verification de la session");
            logout();
        }

        const authvars = await apiResponseBody(session, resp);

        return {session: session, ...authvars};
    } catch (_) { logout(); }
}

/**
@param {string} id
@param {Object} post
@param {Session} session
@param {string} variant
*/
export async function toggleComments(id, post, session, variant) {
    if (!(post.comments instanceof Array)) {
        const resp = await apiRequest(session, variant + ".comments.get", {id: id});
        if (!resp.ok) communicationError(`Erreurs lors du chargement des commentaires`);
        post.comments = await apiResponseBody(session, resp);
        post.commentsVisible = true;
        return;
    }

    post.commentsVisible = !post.commentsVisible;
}

/**
@param {string} id
@param {Object} post
@param {string} comment
@param {Session} session
@param {string} variant
*/
export async function commentPost(id, post, comment, session, variant) {
    if (!confirm(`Poster un commentaire est irréverible, continuer?`)) return;
    const resp = await apiRequest(session, variant + ".comments.post", {id: id, comment: comment});
    if (!resp.ok) communicationError("Erreur commentaire poste");
    post.comments = 0;
    toggleComments(id, post, session, variant);
} 
